import * as actionTypes from "../Home/action-types";

export const setFocusWebsiteField = (dispatch, data) => {
    dispatch({ type: actionTypes.SET_FOCUS_WEBSITE_FIELD, payload: data });
}